import {OnDestroy} from '@angular/core';
import {fromEvent, Subscription} from 'rxjs';
import {debounceTime, share} from 'rxjs/operators';

const $resize = fromEvent(window, 'resize').pipe(share(), debounceTime(500));

export abstract class Container implements OnDestroy {

  private _subscription: Subscription = new Subscription();

  protected constructor() {
    this.addSubscription($resize.subscribe(() => {
      this.resize();
    }));
  }

  abstract resize();

  addSubscription(teardown) {
    this._subscription.add(teardown);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this._subscription = null;
  }
}
